export const CHAT_ACTION_PERSIST = "CHAT_PERSIST";
export const CHAT_ACTION_CLEAR = "CHAT_CLEAR";
